import React from 'react'
import { Col, Row } from 'react-bootstrap'
import BrainLeft from './BrainLeft'
import BrainRight from './BrainRight'

const Brain = () => {
  return (
    <>
      <Row>
        <Col md={6}>
          <BrainLeft />
        </Col>
        <Col md={6}>
          <BrainRight />
        </Col>
      </Row>
    </>
  )
}

export default Brain
